import { Component, Input, Output, EventEmitter, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';

export interface SlideshowItem {
    img: string;
    imgMob: string;
    label: string;
}

@Component({
    selector: 'app-bg-slideshow',
    templateUrl: './bg-slideshow.component.html',
    styleUrls: ['./bg-slideshow.component.scss']
})
export class BgSlideshowComponent implements OnChanges, OnDestroy {
    @Input() items: SlideshowItem[] = [];
    @Input() isMobile: boolean = false;
    @Input() active: boolean = false;
    @Output() completed = new EventEmitter<void>();
    @Output() labelChange = new EventEmitter<string | null>();

    private _paused: boolean = false;
    @Input() set paused(val: boolean) {
        this._paused = val;
        if (!this.active) return;
        if (val) {
            clearTimeout(this.timer);
        } else {
            this.scheduleNext();
        }
    }

    imgA: string = '';
    imgB: string = '';
    showA: boolean = true;
    private currentIndex: number = 0;
    private timer: any;
    private labelTimer: any;

    ngOnChanges(changes: SimpleChanges) {
        if (changes['active']) {
            if (this.active) {
                this.start();
            } else {
                this.stop();
                this.reset();
            }
        }
    }

    ngOnDestroy() {
        this.stop();
        clearTimeout(this.labelTimer);
    }

    private src(item: SlideshowItem): string {
        return this.isMobile ? item.imgMob : item.img;
    }

    private start() {
        if (!this.items?.length) return;
        this.currentIndex = 0;
        const item = this.items[0];
        this.imgA = this.src(item);
        this.imgB = '';
        this.showA = true;
        setTimeout(() => this.labelChange.emit(item.label || null), 0);
        this.scheduleNext();
    }

    private stop() {
        clearTimeout(this.timer);
        clearTimeout(this.labelTimer);
    }

    private reset() {
        this.currentIndex = 0;
        // this.imgA = '';
        // this.imgB = '';
        this.showA = true;
        this.labelChange.emit(null);
    }

    private scheduleNext() {
        if (this._paused) return;
        this.timer = setTimeout(() => this.advance(), 5000);
    }

    private advance() {
        this.currentIndex++;

        if (this.currentIndex >= this.items.length) {
            this.labelChange.emit(null);
            this.completed.emit();
            return;
        }

        const item = this.items[this.currentIndex];
        const nextSrc = this.src(item);

        if (this.showA) {
            this.imgB = nextSrc;
            this.showA = false;
        } else {
            this.imgA = nextSrc;
            this.showA = true;
        }

        // Brief null so *ngIf destroys/recreates the label div and re-triggers the fade animation
        this.labelChange.emit(null);
        clearTimeout(this.labelTimer);
        this.labelTimer = setTimeout(() => this.labelChange.emit(item.label || null), 50);

        this.scheduleNext();
    }
}
